import "./Holdings.module.css";
import Header from "@/reusable_sections/Header";
import IndustriesBrands from "./sections/IndustriesBrands";
import CommunityBenefits from "./sections/CommunityBenefits";
import RaceEngineeringCore from "./sections/RaceEngineeringCore";
import Footer from "@/reusable_sections/Footer";
export default function HoldingsPage() {
  return <div>
      <Header />
      <IndustriesBrands />
      <CommunityBenefits />
      <RaceEngineeringCore />
      <Footer />
    </div>;
}